/**
 * Возвращает цвет заливки в зависимости от состояния элемента.
 *
 * @param {boolean} isActive - Является ли элемент активным.
 * @param {boolean} isHovered - Наведен ли курсор на элемент.
 * @param {boolean} isMouseDown - Находится ли элемент в состоянии нажатия (mousedown).
 * @returns {string} CSS-переменная цвета заливки для текущего состояния.
 */

export const getFillColor = (
  isActive: boolean,
  isHovered: boolean,
  isMouseDown: boolean
): string => {
  if (isActive && isMouseDown) return 'var(--mui-palette-widgetTabs-backgroundColorAblePressed)';
  if (isActive && isHovered) return 'var(--mui-palette-widgetTabs-backgroundColorAbleHover)';
  if (isActive) return 'var(--mui-palette-widgetTabs-backgroundColorAbleDefault)';
  return 'var(--mui-palette-background-paper)';
};
